import React, { useEffect, useRef } from 'react';
import { AlertCircle, CheckCircle, X } from 'lucide-react';

interface PasswordValidationPopupProps {
  isVisible: boolean;
  errors: string[];
//   password: string;
  onClose: () => void;
}

const PasswordValidationPopup: React.FC<PasswordValidationPopupProps> = ({
  isVisible,
  errors,
//   password,
  onClose
}) => {
  const popupRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
        onClose();
      }
    };

    if (isVisible) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isVisible, onClose]);

  if (!isVisible || errors.length === 0) return null;

  // Define validation rules that correspond to the error messages
  const validationRules = [
    'At least 8 characters',
    'At least one lowercase letter',
    'At least one uppercase letter',
    'At least one number',
    'At least one special character (@$!%*?&)',
  ];

  return (
    <div className="password-validation-popup-container">
      <div 
        ref={popupRef}
        className="password-validation-popup"
      >
        {/* Header */}
        <div className="password-validation-popup-header">
          <div className="flex items-center space-x-2">
            <AlertCircle className="h-5 w-5 text-red-500" />
            <h3 className="text-sm font-semibold text-gray-900">
              Password Requirements
            </h3>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X className="h-4 w-4" />
          </button>
        </div>

        {/* Content */}
        <div className="password-validation-popup-content">
          <div className="space-y-2">
            {validationRules.map((rule, index) => {
              const isValid = !errors.includes(rule);
              const IconComponent = isValid ? CheckCircle : AlertCircle;

              return (
                <div key={index} className="flex items-center space-x-2">
                  <div className={`flex-shrink-0 ${isValid ? 'text-green-500' : 'text-red-500'}`}>
                    <IconComponent className="h-4 w-4" />
                  </div>
                  <span className={`text-xs ${isValid ? 'text-green-700' : 'text-red-700'}`}>
                    {rule}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PasswordValidationPopup; 